import { translate } from '@jsverse/transloco';
export enum Severity {
    UNKNOWN = 'UNKNOWN',
    INFO = 'INFO',
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    CRITICAL = 'CRITICAL',
}

export class SeverityHelper {
    static getSeverityLocale(severity: Severity): string {
        switch (severity) {
            case Severity.CRITICAL:
                return translate('CORE.SEVERITIES.CRITICAL');
            case Severity.HIGH:
                return translate('CORE.SEVERITIES.HIGH');
            case Severity.MEDIUM:
                return translate('CORE.SEVERITIES.MEDIUM');
            case Severity.LOW:
                return translate('CORE.SEVERITIES.LOW');
            case Severity.INFO:
                return translate('CORE.SEVERITIES.INFO');
            case Severity.UNKNOWN:
                return translate('CORE.SEVERITIES.UNKNOWN');
            default:
                return '';
        }
    }

    static getSeverityBadgeIcon(severity: Severity): string {
        switch (severity) {
            case Severity.CRITICAL:
                return 'keyboard_double_arrow_up';
            case Severity.HIGH:
                return 'keyboard_arrow_up';
            case Severity.MEDIUM:
                return 'drag_handle';
            case Severity.LOW:
                return 'keyboard_double_arrow_down';
            case Severity.INFO:
                return 'info';
            case Severity.UNKNOWN:
                return 'help_outline';
            default:
                return '';
        }
    }

    static getSeverityBadgeStatus(severity: Severity): string {
        switch (severity) {
            case Severity.CRITICAL:
                return 'error';
            case Severity.HIGH:
                return 'error';
            case Severity.MEDIUM:
                return 'warning';
            case Severity.LOW:
                return 'success';
            case Severity.INFO:
                return 'info';
            case Severity.UNKNOWN:
                return 'neutral';
            default:
                return 'neutral';
        }
    }

    static getSeverityColor(severity: Severity): string {
        switch (severity) {
            case Severity.CRITICAL:
                return '#821811';
            case Severity.HIGH:
                return '#D92C26';
            case Severity.MEDIUM:
                return '#F29F05';
            case Severity.LOW:
                return '#05943E';
            case Severity.INFO:
                return '#037DB8';
            case Severity.UNKNOWN:
                return '#B7BBCC';
            default:
                return '#B7BBCC';
        }
    }
}
